import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)

const langFiles = require.context('./config', false, /\.js$/)

const regExp = /.\/([^./]+)\.([^.]+)$/

const messages = {}
const lang = {
  zh: zhCNLocale,
  en: enLocale
}
langFiles.keys().forEach(key => {
  const k = regExp.exec(key)[1]
  messages[k] = Object.assign(langFiles(key).default, lang[k])
})

const locale = localStorage.getItem('lang') || 'zh'

export default new VueI18n({
  locale,
  messages
})
